import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'

// Load reducers
import reducers from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore(history, initialState) {
  let store = createStore(
    combineReducers(reducers),
    composeEnhancers(applyMiddleware(thunk), applyMiddleware(routerMiddleware(history)))
  )

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const newRootReducer = require('./reducers').default
      store.replaceReducer(newRootReducer)
    })
  }

  return store
}
